define.alias("shared/components/shared/post/secondary/hashtag-suggestions/table", "preview-grid/components/shared/post/secondary/hashtag-suggestions/table");